
<ng-container *ngTemplateOutlet="templates['template-resumen-info'];"></ng-container>
<ng-container *ngTemplateOutlet="templates['template-resumen-relationship'];"></ng-container>
<ng-container *ngTemplateOutlet="templates['template-resumen-operation-data'];"></ng-container>
<ng-container *ngTemplateOutlet="templates['template-resumen-documentation'];"></ng-container>
<ng-container *ngTemplateOutlet="templates['template-resumen-related'];"></ng-container>
<ng-container *ngTemplateOutlet="templates['template-resumen-responses'];"></ng-container>
